import { jsx as _jsx } from "react/jsx-runtime";
import { AlertLoader } from "syf-component-library/ui/atoms";
import { useAccountSummary, useStatementsEnrollment, } from "../../../../../const/syfApiQueries";
import { useStatementsContext } from "../../../../../context/statementsContext";
import EnrollCard from "../../../../molecules/EnrollCard";
import EnrollmentPageError from "../../../../molecules/EnrollmentPageError";
var EnrollmentContent = function () {
    var _a;
    var _b = useStatementsContext().state, accountId = _b.accountId, showEnrollmentError = _b.showEnrollmentError;
    var _c = useStatementsEnrollment(accountId), enrollmentStatusData = _c.data, isEnrollmentStatusLoading = _c.isLoading, isEnrollmentStatusError = _c.isError;
    var _d = useAccountSummary(accountId), accountSummary = _d.data, isAccountSummaryError = _d.isError;
    var isAccountDelinquent = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.conditions.includes("DELINQUENT");
    if (isAccountDelinquent ||
        isAccountSummaryError ||
        isEnrollmentStatusError ||
        showEnrollmentError ||
        (!isEnrollmentStatusLoading &&
            (enrollmentStatusData === null || enrollmentStatusData === void 0 ? void 0 : enrollmentStatusData.availableEnrollmentTypes) &&
            enrollmentStatusData.availableEnrollmentTypes.length <= 0)) {
        return _jsx(EnrollmentPageError, {});
    }
    if (isEnrollmentStatusLoading) {
        return _jsx(AlertLoader, {});
    }
    var enrollmentStatus = enrollmentStatusData.enrollmentType;
    var availableEnrollmentType = (_a = enrollmentStatusData.availableEnrollmentTypes) === null || _a === void 0 ? void 0 : _a[0];
    return (_jsx(EnrollCard, { enrollmentType: enrollmentStatus, availableEnrollmentType: availableEnrollmentType }));
};
export default EnrollmentContent;
